import axios from 'axios';
import { merge } from 'lodash';
import { ApiHttpPaths } from './ApiHttpPaths';
export class AxiosAPI {
    constructor() {
        this.apiSchema = ApiHttpPaths;
        this.apiDomain = this.parseDomain();
        axios.interceptors.request.use((config) => {
            config.headers['Origin'] = window.location.origin;
            return config;
        });
    }
    apiSchema;
    apiDomain = '';
    parseDomain = () => {
        const apiUrl = (window.env && window.env.API_URL !== '__API_URL__' && window.env.API_URL) ||
            process.env.REACT_APP_API_URL ||
            '';
        if (!apiUrl) {
            return window.location.origin;
        }
        if (apiUrl.startsWith('/')) {
            return `${window.location.origin}${apiUrl}`;
        }
        return apiUrl;
    };
    setDefaultHeaders = (options = {}, _path) => {
        options.headers = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            origin: window.location.origin,
            'X-origin': `${window.location.origin.toString()}`,
        };
        options.withCredentials = true;
        return options;
    };
    POST = (path, body, options = {}) => {
        const domain = this.apiDomain;
        const defaultOptions = this.setDefaultHeaders({ timeout: 600000 }, path);
        return axios.post(`${domain}${path.url}`, body, merge(defaultOptions, options));
    };
    GET = (path, options = {}) => {
        const domain = this.apiDomain;
        const defaultOptions = this.setDefaultHeaders({ timeout: 600000 }, path);
        return axios.get(`${domain}${path.url}`, merge(defaultOptions, options));
    };
    PUT = (path, body, options) => {
        const domain = this.apiDomain;
        const defaultOptions = this.setDefaultHeaders({ timeout: 600000 }, path);
        return axios.put(`${domain}${path.url}`, body, merge(defaultOptions, options));
    };
    DELETE = (path, options) => {
        const domain = this.apiDomain;
        const defaultOptions = this.setDefaultHeaders({ timeout: 600000 }, path);
        return axios.delete(`${domain}${path.url}`, merge(defaultOptions, options));
    };
}
